import React, { useEffect, useCallback, useMemo, useState } from 'react';
import './style.scss';
import Btn from "../../components/Btn";
import { API } from "../../API";
import BtnScrlTop from "../../components/BtnScrlTop";
import { History } from "../../components/home/History";
import { Filter } from "../../components/home/Filter";

import { WhatIsIt } from "../../components/widgets/WhatIsIt";
import { YourHelp } from "../../components/widgets/YourHelp";
import { TellEveryone } from "../../components/widgets/TellEveryone";
import ScrollToTop from "../../components/ScrollToTop";
import Loader from "../../components/Loader";
import {YourSupport} from "../../components/widgets/YourSupport";

const Home = () => {

    const [listStory, setListStory]=useState([]);
    const [metaData, setMetaData]=useState({ });
    const [dataCategory, setDataCategory]=useState({ });
    const [loading, setLoading] = useState(true);
    const [getParam, setGetParam] = useState('orderBy=published_at');

    useEffect(() => {
        //console.log('getParam', getParam);
        fetchStory(null, getParam, null);
    }, [getParam]);

    useEffect(() => {

        /*
                //получаем ip пользователя
                axios.get('https://www.cloudflare.com/cdn-cgi/trace')
            .then((data) => {
                console.log('data', data);
                //console.log(JSON.stringify(data, null, 2));
            });*/

        API.get_category()
            .then((res) => {
                setDataCategory(res.data);
            })
            .catch((err) => {
                console.log('get_category ERROR', err);
            });
    }, []);

    const fetchStory = (URL, getParam, continuous) => {
        setLoading(true);

        return new Promise((resolve, reject) => {
            setTimeout(() => {
                API.get_stories(URL, getParam)
                    .then((res) => {
                        //console.log('res', res);
                        let copyList = res.data.items;

                        if (continuous) {
                            copyList = [...listStory, ...res.data.items];
                        }
                        setListStory(copyList);
                        setMetaData(res.data.metadata);

                        resolve(true);
                    })
                    .catch((err) => {
                        console.log('err', err);
                        reject(err);
                    });
            }, 500);
        }).finally(() => {
            setLoading(false);
        });

        /*        return API.get_stories(URL, getParam)
            .then((res) => {
                //console.log('res', res);
                setTimeout(() => {
                    let copyList = res.data.items;

                    if (continuous) {
                        copyList = [...listStory, ...res.data.items];
                    }
                    setListStory(copyList);
                    setMetaData(res.data.metadata);
                    setLoading(false);
                }, 1000);

            })
            .catch((err) => {
                console.log('err', err);
            }).finally(() => {
                setLoading(false);
            });*/

    };

    const onShowMore=() => {
        //console.log('MORE', metaData.nextLink);
        //const saveScrollHeight = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

        fetchStory(metaData.nextLink, null, true)
            .then(() => {
                //window.scrollTo(0, saveScrollHeight);
            });
    };

    const renderWidget = useCallback((ind) => {
        switch (ind+1) {
            case 2:
                return <YourSupport />;
            case 4:
                return <WhatIsIt />;
            case 6:
                return <YourHelp />;
            case 8:
                return <TellEveryone />;
            default:
                return null;
        }
    }, []);

    const renderStory = useMemo(() => {
        return listStory.map((item, index) => {
            return (
                <React.Fragment key = { item.id }>
                    <History history = { item } />
                    {renderWidget(index)}
                </React.Fragment>
            );
        });
    }, [listStory]);

    const onClearList=() => {
        setListStory([]);
    };

    // console.log('listStory.length, metaData.total', listStory.length, metaData.total);

    return (
        <div className = 'home'>
            <div className = 'head-first home__head head__first'>
                <div className = 'home__head-img home-first__img' />
                <div className = ' m-width'>
                    <div className = 'head-first__content'>
                        <h1 className = 'home__title head-first__title'>Мені здається</h1>
                        <p className = 'home__subtext head-first__description'>
                            {/*Потерпілі від насильства не мають боятися говорити про проблему, а кривдники мають перестати кривдити через страх публічного осуду*/}
                            Анонімний онлайн-щоденник
                        </p>
                        <span className = 'head-first__subtitle'>
                            Якщо тобі <b>здається</b>, то тобі <b>не здається</b>
                        </span>
                        <div className = 'head-first__btns'>
                            <div>
                                <Btn
                                    full
                                    theme = 'main'
                                    title = 'Написати історію'
                                    url = '/add-history'
                                />
                            </div>
                            <div>
                                <Btn
                                    full
                                    theme = 'second'
                                    title = 'Що це'
                                    url = '/about'
                                />
                            </div>
                        </div></div>
                </div>
            </div>
            <div className = 'm-width home__filter'>
                <Filter
                    dataCategory = { dataCategory }
                    setGetParam = { setGetParam }
                    onClearList = { onClearList }
                />
            </div>
            <div className = 'body body-column m-width home__body'>
                <div className = 'body-column__content'>
                    {/*                    <Filter
                        dataCategory = { dataCategory }
                        setGetParam = { setGetParam }
                    />*/}
                    <div className = 'home__history' >
                        {renderStory}
                    </div>
                    {loading && <Loader />}
                    <div className = 'home__btns-bottom'>
                        {
                            !loading && listStory.length > 0 && listStory.length !== metaData.total ?
                                <Btn
                                    small
                                    theme = 'main'
                                    title = 'Показати більше'
                                    onPress = { onShowMore }
                                />
                                : null
                        }

                        <div className = 'home__scrollTop'>
                            <BtnScrlTop
                                iconName = 'arrow-bottom'
                                theme = 'second'
                                onPress = { () => {
                                    ScrollToTop(true);
                                } }
                            />
                        </div>
                    </div>
                </div>
                <div className = 'body-column__sidebar'>
                    <YourSupport />
                    <WhatIsIt />
                    <YourHelp />
                    <TellEveryone />
                    <div className = 'home-sidebar__scrollTop'>
                        <BtnScrlTop
                            iconName = 'arrow-bottom'
                            theme = 'main'
                            onPress = { () => {
                                ScrollToTop(true);
                            } }
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Home;
